import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[autoFocus]'
})
export class SetFocusDirective implements AfterViewInit {

  constructor(
    private elementRef: ElementRef,
    private window: Window
) {}

  ngAfterViewInit() {
    this.window.setTimeout(() => {
        this.elementRef.nativeElement.focus();
    }, 500);
  }
}